module.exports = __webpack_public_path__ + "static/media/innobiz.16403bdf.png";